var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteFlourishIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 92,
    viewBox: "0 0 164 92",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_2827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2 29.8H46C53.6 29.8 60.4 32.7333 66.4 38.6C72.5333 44.3333 75.6 51.5333 75.6 60.2C75.6 68.7333 72.5333 75.8 66.4 81.4C60.4 86.8667 52.9333 89.6 44 89.6C34.2667 89.6 26.1333 85.7333 19.6 78C13.2 70.1333 10 59 10 44.6C10 31.4 12.8 19.0667 18.4 7.6C24.1333 -4 31.0667 -13.1333 39.2 -19.8C47.4667 -26.6 54.8 -30 61.2 -30C65.4667 -30 68.8 -28.7333 71.2 -26.2C73.6 -23.6667 74.8 -20.4 74.8 -16.4C74.8 -10.5333 72.2 -6.2 67 -3.4C59.9333 0.466667 54.3333 5 50.2 10.2C46.0667 15.4 43.7333 21.9333 43.2 29.8ZM131.6 29.8H134.2C141.667 29.8 148.4 32.7333 154.4 38.6C160.533 44.3333 163.6 51.5333 163.6 60.2C163.6 68.6 160.533 75.6667 154.4 81.4C148.4 87.1333 140.933 90 132 90C122.133 90 114 86 107.6 78C101.2 70 98 58.8667 98 44.6C98 34.3333 99.6667 24.6667 103 15.6C106.333 6.53334 110.6 -1.33333 115.8 -8C121.133 -14.8 126.8 -20.1333 132.8 -24C138.933 -28 144.4 -30 149.2 -30C153.6 -30 156.933 -28.7333 159.2 -26.2C161.6 -23.8 162.8 -20.5333 162.8 -16.4C162.8 -10.4 160.2 -6.06667 155 -3.4C147.667 0.733335 142.133 5.33334 138.4 10.4C134.667 15.3333 132.4 21.8 131.6 29.8Z",
    fill: "#83C887"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_2827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 92,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteFlourishIcon);
export default __webpack_public_path__ + "static/media/quoteFlourishIcon.38b11443796ac0a3e68a513c3906d093.svg";
export { ForwardRef as ReactComponent };